module.exports = __webpack_public_path__ + "assets/img/2.62b58ee4.png";